import withSubmitHOC from "@common/controls/Modal/Modals/hocs/withSubmit";
export default withSubmitHOC;

export * from "@common/controls/Modal/Modals/hocs/withSubmit";
